import React, {useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {Badge, Box, IconButton, Menu, MenuItem, Typography} from "@material-ui/core";
import NotificationImportantIcon from "@material-ui/icons/NotificationImportant";
import CheckIcon from "@material-ui/icons/Check";

import {useNavStyles} from "./Navbar";
import {
  getKpiNotifications,
  markAllKpiNotificationsRead,
  markKpiNotificationRead,
} from "../../pages/huntersKpi/api";
import {setShowModal} from "../../services/redux/actions/app-actions";
import {MODALS} from "../../constants";
import cookiesService from "../../services/cookiesService";

const cookiesServiceInstance = cookiesService.getService();

// TZ раздел 5.5 — алерты (streak/fail_streak/новичок завершил период) через существующий
// KPI-механизм уведомлений (sale.kpi_notification_tab / /crm/kpi/notifications/*), а не через
// общий "notice" (тот — для рассылок, не для адресных KPI-алертов).
export const KpiAlerts = () => {
  const classes = useNavStyles();
  const dispatch = useDispatch();
  const {position_code} = cookiesServiceInstance.getUserData();
  const canManageGrades = position_code === "SALE_HEAD" || position_code === "SALE_HEAD_HEAD";

  const [notifications, setNotifications] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  const fetchNotifications = useCallback(() => {
    getKpiNotifications()
      .then(res => {
        setNotifications(res || []);
      })
      .catch(() => {
      });
  }, []);

  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications]);

  if (!notifications.length) return null;

  const unreadCount = notifications.filter(el => !el.is_read).length;

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRead = id => {
    markKpiNotificationRead(id).then(res => {
      setNotifications(res || []);
    });
  };

  const handleReadAll = () => {
    markAllKpiNotificationsRead().then(res => {
      setNotifications(res || []);
    });
  };

  const handleAssignGrade = notif => {
    handleClose();
    dispatch(
      setShowModal(true, MODALS.changeGradeModal, {
        title: "Изменение грейда",
        hunterId: notif.hunter_id,
        hunterFio: notif.hunter_fio,
        onSaved: fetchNotifications,
      })
    );
  };

  return (
    <Box className={classes.notification_block}>
      <IconButton onClick={handleClick}>
        <Badge badgeContent={unreadCount} color="error">
          <NotificationImportantIcon/>
        </Badge>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{style: {maxWidth: 420}}}
      >
        {notifications.map(el => (
          <MenuItem
            key={el.kpi_notification_id}
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 8,
              whiteSpace: "normal",
              opacity: el.is_read ? 0.6 : 1,
            }}
          >
            <Box style={{flex: 1}}>
              <Typography variant="body2">{el.message}</Typography>
              <Typography variant="caption" color="textSecondary">
                {el.date_created}
              </Typography>
              {canManageGrades && el.notification_type === "NEWBIE_TRANSFER" && !el.is_read ? (
                <Box>
                  <Typography
                    variant="body2"
                    style={{color: "#6191EF", cursor: "pointer"}}
                    onClick={() => handleAssignGrade(el)}
                  >
                    Назначить грейд
                  </Typography>
                </Box>
              ) : null}
            </Box>
            {!el.is_read ? (
              <IconButton size="small" onClick={() => handleRead(el.kpi_notification_id)}>
                <CheckIcon fontSize="small"/>
              </IconButton>
            ) : null}
          </MenuItem>
        ))}
        <MenuItem onClick={handleReadAll} style={{justifyContent: "center", color: "#6191EF"}}>
          Прочитать все
        </MenuItem>
      </Menu>
    </Box>
  );
};
